import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Logo from '../../assets/images/fav3.0.png';

const Spinners = ({ setLoading, timerStop }) => {
  useEffect(() => {
    if (!timerStop) {
      const timer = setTimeout(() => {
        setLoading(false);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [setLoading, timerStop]);

  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center vh-100 vw-100 position-fixed top-0 start-0 z-3"
      style={{ background: 'rgba(0,0,0,.1)' }}
    >
      <div className="custom-spinner">
        <img src={Logo} alt="Logo" className="spinner-logo" />
      </div>
      <p className="m-0 text-dark mt-3" style={{ fontSize: '20px', fontWeight: 'bold' }}>
        Loading ...
      </p>

      {/* Custom CSS */}
      <style>
        {`
          .custom-spinner {
            width: 80px;
            height: 80px;
            border: 5px solid #ccc;
            border-top: 5px solid #000;
            border-radius: 50%;
            animation: spin 1s linear infinite;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
          }

          .spinner-logo {
            width: 40px;
            height: 40px;
            object-fit: contain;
            position: absolute;
          }

          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

Spinners.propTypes = {
  setLoading: PropTypes.func.isRequired,
  timerStop: PropTypes.any
};

export default Spinners;
